<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.patients', 2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card-title ml-3">
                    <router-link :to="{ name: 'add-patient' }" v-if="can || hasPraticienRole || hasMedecinControleRole || hasAssistante">
                        {{ $t('message.add') }}

                        <i class="fas fa-plus-circle edit-icon"></i>
                    </router-link>
                </div>
                <b-container>
                    <b-row class="justify-content-sm-center">
                        <b-col col sm="12">
                            <!--                                <b-form-group>-->
                            <div class="vgt-global-search vgt-clearfix">
                                <div class="vgt-global-search__input vgt-pull-left"><span class="input__icon">
                                        <div class="magnifying-glass">

                                        </div>
                                    </span>
                                    <input type="text" placeholder="Search user" class="vgt-input vgt-pull-left" v-model="searchTerm">
                                </div>
                                <div class="vgt-global-search__actions vgt-pull-right">

                                </div>
                            </div>
                            <vue-good-table
                                id="operation"
                                :columns="patientsColumns"
                                :rows="mPatientsFilter"
                                :search-options="{
                                    enabled:true,
                                    externalQuery: searchTerm
                                    }"
                                :pagination-options="paginationOptions"
                                @on-cell-click="onPatientClick">
                                <template slot="table-row" slot-scope="props" v-if="props.column.field == 'souscripteur_id'">
                                    <a href="#" v-if="props.row.souscripteur_id == null">
                                    <i class="fas fa-plus"></i> {{$t('message.add_souscripteur')}}
                                    </a>
                                    <div v-else>Existe</div>
                                </template>
                            </vue-good-table>
                        </b-col>
                    </b-row>
                </b-container>
                <div>
                    <b-modal :id="'modal-'+patient_id" centered :title="'Ajout du souscripteur au patient '+nom">
                        <p class="my-1">Nom: {{ nom }}</p>
                        <p class="my-1">Email: {{ email }}</p>
                        <p class="my-1">Numéro de dossier: {{ numero_dossier }}</p>
                        <div class="row">
                            <div class="form-group col-md-12">
                                <span class="obligatoire">*</span>
                                <label for="souscripteur_search">Souscripteur</label>
                                <autocomplete
                                    :search="getSouscripteurs"
                                    placeholder="Recherchez le souscripteur"
                                    aria-label="Recherchez le souscripteur"
                                    :get-result-value="getValueSouscripteur"
                                    @submit="chooseSouscripteur"
                                ></autocomplete>
                                <input type="hidden" name="souscripteur_id" id="souscripteur_id" v-model="souscripteur_id" class="form-control" v-validate="'required'" :class="errors.has('souscripteur_id') ? 'is-invalid' : ''"/>
                                <small id="emailHelp" class="form-text text-danger">{{ erreur }}</small> 
                            </div>
                        </div>
                        <template #modal-footer>
                            <div class="d-flex justify-content-center" v-if="isLoading">
                                <div class="loading"></div>
                            </div>
                            <button type="submit" @click="onSubmit" class="btn btn-success" v-else>Créer</button>
                        </template>
                    </b-modal>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import Swal from 'sweetalert2';
    import Autocomplete from '@trevoreyre/autocomplete-vue'
    import '@trevoreyre/autocomplete-vue/dist/style.css'
    import _ from 'lodash';
    import AppConfig from '../../constants/AppConfig';

    export default {
        name: "Patients",
        components: {
            Autocomplete,
        },
        computed: {
            ...mapGetters(["patients",'hasAdminRole',
                'hasGestionnaireRole','hasPraticienRole','hasMedecinControleRole',
                'hasAssistante']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasAssistante;
            },

            

            rows: function() {
                return this.mPatients.length;
            }
        },

        data() {
            return {
                perPage: 10,
                currentPage: 1,
                sortBy: 'date',
                sortDesc: true,
                mPatientsFilter : [],
                searchTerm : '',
                patient_id: '',
                nom: '',
                email: '',
                numero_dossier: '',
                souscripteur_id: '',
                isLoading: false,
                erreur: '',
                patientsColumns: [
                    {
                        field: 'nom',
                        label: this.$i18n.t('message.name'),
                    },
                    {
                        field: 'numero_dossier',
                        label: this.$i18n.t('message.fileNumber'),
                    },
                    {
                        field: 'email',
                        label: this.$i18n.t('message.email'),
                    },
                    {
                        field: 'telephone',
                        label: this.$i18n.t('message.phoneNumber'),
                    },
                    /*{
                        field: 'sexe',
                        label: this.$i18n.t('message.gender'),
                    },*/
                    {
                        field: 'nationalite',
                        label: this.$i18n.t('message.nationality'),
                    },
                    {
                        field: 'adresse',
                        label: this.$i18n.t('message.address'),
                    },
                    {
                        field: 'souscripteur_id',
                        label: this.$i18n.t('message.add_souscripteur'),
                    },
                ],
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },
                offset: 0,
                limit: -1,
            }
        },

        watch:{
            searchTerm: async function (newValue, oldValue) {
                if (newValue.trim().length ==0){
                    this.mPatientsFilter = [];
                }else{
                    if(newValue.trim().length ==3){
                        if(oldValue.length == 0){
                            await this.getSearchPatient(newValue);
                            this.mPatientsFilter = this.mPatients();
                        }
                        else 
                        // await this.getSearchPatient(newValue);
                        this.mPatientsFilter = this.mPatients();
                    }
                    else{
                        if(newValue.trim().length >1)
                        this.getSearchPatient(newValue);
                        this.mPatientsFilter = this.mPatients();
                    
                    }
                    
                }
            }
        },

        methods: {
            async getSearchPatient(value) {
                let args = {
                    patient: value
                };

                await this.$store.dispatch("getSearchPatient", {
                    args : args
                });
            },

            mPatients() {
                let pArray = [];

                _.forEach(_.orderBy(this.patients,['created_at'],['desc']), function(patient) {
                    let p = {};

                    if((typeof patient.user == 'object') && (!_.isNull(patient.user)) ) {
                        if (!_.isNull(patient.dossier)){
                            let prenom = patient.user.prenom ? patient.user.prenom : '';
                            prenom =  prenom.toLowerCase();
                            p.nom =  (patient.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                            p.email = patient.user.email;
                            p.telephone = patient.user.telephone;
                            p.sexe = patient.sexe;
                            p.nationalite = patient.user.nationalite;
                            p.ville = patient.user.ville;
                            p.pays = patient.user.pays;
                            p.date = moment(patient.user.date_de_naissance).format('DD-MM-YYYY');
                            p.id = patient.user.id;
                            p.slug = patient.user.slug;
                            p.adresse = patient.user.adresse;
                            p.fileSlug = patient.dossier.slug;
                            p.numero_dossier = patient.dossier.numero_dossier;
                            p.souscripteur_id = patient.souscripteur_id
                        }
                    }
                    pArray.push(p);
                });

                return pArray;
            },
            onPatientClick(params){
                this.patient_id = params.row.id,
                this.nom = params.row.nom,
                this.email = params.row.email,
                this.numero_dossier = params.row.numero_dossier;
                if(params.column.field == "souscripteur_id"){
                    this.erreur = '';
                    this.$bvModal.show('modal-'+params.row.id);
                }else{
                    this.$router.push({ name: 'patient', params: { patient: params.row.slug } });
                }
            },

            getPatients() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getPatients', { args : args });
            },
            getSouscripteurs(input) {
                return new Promise(resolve => {
                    if (input.length < 3) {
                    return resolve([])
                    }
                    fetch(AppConfig.apiUrl+'/search/souscripteurs/'+input, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}})
                    .then(res => res.json())
                    .then(res => {
                        resolve(res.souscripteurs)
                    }).catch(error => {
                        console.log('error ', error);
                    })
                })
            },
            getValueSouscripteur(result) {
                return result.user.nom +' '+result.user.prenom +' ('+result.user.email+')'
            },
            chooseSouscripteur(result) {
                this.souscripteur_id = result.user_id;
            },

            onSubmit() {
                let data = new FormData();
                data.append( "souscripteur_id", this.souscripteur_id);
                data.append( "patient_id", this.patient_id);
                this.isLoading = true;
                if(this.souscripteur_id != ''){
                    fetch(AppConfig.apiUrl+'/souscripteur/assigin_patient', {headers: 
                            {
                                'Authorization': "Bearer " + localStorage.getItem('ms-token'),
                            },
                                method: 'POST',
                                body: data})
                            .then(res => res.json())
                            .then(res => {
                                this.erreur = "";
                                Swal.fire({
                                    title: "Opération réussie",
                                    text: "Le sousscripteur a été modifié avec succès",
                                    icon: 'success',
                                })
                                this.isLoading = false;
                                this.searchTerm = "";
                                this.$bvModal.hide('modal-'+this.patient_id); 
                            }).catch(error => {
                                console.log('error ', error);
                    }) 
                }else{
                    this.erreur = "Sélectionnez le souscripteur";
                    this.isLoading = false;
                }
            },

            deletePatient(patient) {
                let self = this;

                let args = {
                    patient: patient
                };

                let successMessage = this.$i18n.t('message.patientDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deletePatient', { args, index: patient, successMessage, errorMessages })
                    .then(() => {
                        self.$bvModal.hide('delete-modal-' + patient);
                    });
            }
        },

        mounted() {
            // Fetch patient list
            // this.getPatients();
        }
    }
</script>

<style scoped>

</style>